(function () {
  console.log("🧩 [Accordion] Avvio...");

  /* =====================================================
   *   🔹 Mostra / Nasconde sezioni
   * ===================================================== */
  function showContent(wrapper) {
    const nodes = getContentNodes(wrapper);
    nodes.forEach((el) => {
      // Se dropdown → mostra inline, altrimenti block
      el.style.display =
        wrapper.classList.contains("pplr-dropdown") && el.classList?.contains("pplr-drop-item")
          ? "inline-block"
          : "block";
      el.style.maxHeight = "none";
      el.style.overflow = "visible";
    });
    wrapper.classList.add("active");

    // pplr-text: label + input visibili solo quando aperta
    if (wrapper.classList.contains("pplr-text")) {
      const lab = wrapper.querySelector(".pplrlabel");
      const input = wrapper.querySelector(".pplr_text");
      if (lab) lab.style.display = "block";
      if (input) input.style.display = "block";

      // Se è "Misure" (collo), apri tutti i pplr-text successivi
      if (wrapper.classList.contains("pplr-collo")) {
        let next = wrapper.nextElementSibling;
        while (next && next.classList.contains("pplr-text")) {
          next.classList.add("active");
          const nLab = next.querySelector(".pplrlabel");
          const nInp = next.querySelector(".pplr_text");
          if (nLab) nLab.style.display = "block";
          if (nInp) {
            nInp.style.display = "block";
            nInp.style.maxHeight = "none";
            nInp.style.overflow = "visible";
          }
          next = next.nextElementSibling;
        }
      }
    }
  }

  function hideContent(wrapper) {
    const nodes = getContentNodes(wrapper);
    nodes.forEach((el) => {
      el.style.display = "none";
      el.style.maxHeight = "0";
      el.style.overflow = "hidden";
    });
    wrapper.classList.remove("active");

    // pplr-text: label + input nascosti quando chiusa
    if (wrapper.classList.contains("pplr-text")) {
      const lab = wrapper.querySelector(".pplrlabel");
      const input = wrapper.querySelector(".pplr_text");
      if (lab) lab.style.display = "none";
      if (input) {
        input.style.display = "none";
        input.style.maxHeight = "0";
        input.style.overflow = "hidden";
      }

      // Se chiudo "Misure", chiudi anche i successivi
      if (wrapper.classList.contains("pplr-collo")) {
        let next = wrapper.nextElementSibling;
        while (next && next.classList.contains("pplr-text")) {
          next.classList.remove("active");
          const nLab = next.querySelector(".pplrlabel");
          const nInp = next.querySelector(".pplr_text");
          if (nLab) nLab.style.display = "none";
          if (nInp) {
            nInp.style.display = "none";
            nInp.style.maxHeight = "0";
            nInp.style.overflow = "hidden";
          }
          next = next.nextElementSibling;
        }
      }
    }
  }

  /* =====================================================
   *   🔹 Toggle principale
   * ===================================================== */
  function toggleAccordion(wrapper) {
    const isActive = wrapper.classList.contains("active");
    const allWrappers = document.querySelectorAll(".pplr-wrapper");
    allWrappers.forEach((w) => hideContent(w));
    if (!isActive) showContent(wrapper);
  }

  /* =====================================================
   *   🔹 Determina i contenuti interni da mostrare/nascondere
   * ===================================================== */
  function getContentNodes(wrapper) {
    // Dropdown: select o drop-item
    if (wrapper.classList.contains("pplr-dropdown")) {
      const drops = wrapper.querySelectorAll(".pplr-drop-item");
      if (drops.length) return Array.from(drops);
      const sel = wrapper.querySelector("select");
      if (sel) return [sel];
    }

    // Checkbox: tutti i label .pplr_checkbox_l
    if (wrapper.classList.contains("pplr-checkbox")) {
      const checkLabels = wrapper.querySelectorAll(".pplr_checkbox_l");
      if (checkLabels.length) return Array.from(checkLabels);
    }

    // Standard (immagini, testo, ecc.)
    const n =
      wrapper.querySelector(".pplr_thumb_image") ||
      wrapper.querySelector("select") ||
      wrapper.querySelector(".pplr_text") ||
      wrapper.querySelector(".pplr-drop-item");
    return n ? [n] : [];
  }

  /* =====================================================
   *   🔹 Inizializza l’accordion
   * ===================================================== */
  function initAccordion() {
    const wrappers = document.querySelectorAll(".pplr-wrapper");
    if (!wrappers.length) return;

    wrappers.forEach((wrapper, i) => {
      // trigger: .oindexlabel per pplr-text, altrimenti .pplrlabel
      let label = wrapper.classList.contains("pplr-text")
        ? wrapper.querySelector(".oindexlabel")
        : wrapper.querySelector(".pplrlabel");

      const contentNodes = getContentNodes(wrapper);
      if (!label || !contentNodes.length) return;

      if (label.hasAttribute("onclick")) label.removeAttribute("onclick");

      if (i === 0) showContent(wrapper);
      else hideContent(wrapper);

      if (!label._accordionHandler) {
        label._accordionHandler = (e) => {
          e.preventDefault();
          const isActive = wrapper.classList.contains("active");
          document.querySelectorAll(".pplr-wrapper").forEach((w) => hideContent(w));
          if (!isActive) showContent(wrapper);
        };
        label.addEventListener("click", label._accordionHandler);
      }
    });
  }

  /* =====================================================
   *   🔹 Checkbox singola selezione (Sostegno colletto)
   * ===================================================== */
  /*document.addEventListener("change", (e) => {
    const box = e.target.closest(".pplr-checkbox-item");
    if (!box) return;

    const group = box.closest(".pplr-wrapper.pplr-checkbox");
    if (!group) return;

    // Deseleziona tutti gli altri checkbox dello stesso gruppo
    group.querySelectorAll(".pplr-checkbox-item").forEach((cb) => {
      if (cb !== box) cb.checked = false;
    });
  });*/

  /* =====================================================
   *   🔹 Swatch: da background a <img>
   * ===================================================== */
  function convertSwatchesToImg(root = document) {
    const swatches = root.querySelectorAll(".pplr-swatch-element.pplrimage");

    swatches.forEach((swatch) => {
      if (swatch.querySelector(":scope > img.pplr-swatch-img")) return;
      let src = swatch.getAttribute("data-image") || swatch.dataset.image;

      if (!src) {
        const bg = getComputedStyle(swatch).backgroundImage;
        const match = bg && bg.match(/url\\(["']?(.*?)["']?\\)/i);
        src = match ? match[1] : null;
      }
      if (!src) return;

      const img = document.createElement("img");
      img.className = "pplr-swatch-img";
      img.src = src;
      img.alt = swatch.getAttribute("data-val") || "";
      swatch.insertBefore(img, swatch.firstChild);
      swatch.style.backgroundImage = "none";
    });

    console.log("🖼️ [Swatches] Background convertiti in <img>");
  }

  /* =====================================================
   *   🔹 Rimuove trattini tipo " - Liscio"
   * ===================================================== */
  function cleanOptionTextSpans(root = document) {
    const spans = root.querySelectorAll(".pplr_option_text_span");
    spans.forEach((span) => {
      const txt = span.textContent.trimStart();
      if (txt.startsWith("-")) {
        span.textContent = txt.replace(/^-+\s*/, "");
      }
    });
  }

  function observeOptionText() {
    const spans = document.querySelectorAll(".pplr_option_text_span");
    spans.forEach((span) => observeSingleSpan(span));

    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        m.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            if (node.matches(".pplr_option_text_span")) {
              observeSingleSpan(node);
              cleanOptionTextSpans(document);
            } else {
              node.querySelectorAll?.(".pplr_option_text_span").forEach(observeSingleSpan);
            }
          }
        });
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    console.log("👁️ [Observer] Attivo su span esistenti + nuovi");
  }

  function observeSingleSpan(span) {
    if (span._observed) return;
    span._observed = true;
    const innerObserver = new MutationObserver(() => cleanOptionTextSpans(document));
    innerObserver.observe(span, { characterData: true, subtree: true, childList: true });
  }

  /* =====================================================
   *   🔹 Avvio e osservatori
   * ===================================================== */
  function initAll() {
    initAccordion();
    convertSwatchesToImg(document);
    cleanOptionTextSpans(document);
  }

  function waitForPersonalizer() {
    const target = document.querySelector(".pplr_thumb_image");
    if (target) {
      console.log("🎯 [Accordion] Zepto personalizer trovato, inizializzo...");
      initAll();
      observeOptionText();

      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          for (const node of mutation.addedNodes) {
            if (node instanceof HTMLElement && node.classList.contains("pplr-wrapper")) {
              console.log("♻️ [Accordion] Nuova sezione rilevata, reinizializzo...");
              initAll();
              cleanOptionTextSpans(document);
              return;
            }
          }
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      return;
    }
    console.log("⌛ [Accordion] In attesa del personalizer...");
    setTimeout(waitForPersonalizer, 500);
  }

  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", waitForPersonalizer)
    : waitForPersonalizer();
})();

const el = document.querySelector('.price.price--product');
if (el) {
  el.style.removeProperty('display');
  el.style.display = 'block'; // oppure 'flex', 'inline-block', a seconda del layout
}

setTimeout(function() {
  const el = document.querySelector('.price.price--product');
  if (el) {
    el.setAttribute("style", "display: block !important");
  }
  const el1 = document.querySelector('span.hengam-price.hengam-final-price');
  if (el1) {
    el1.setAttribute("style", "display: none !important");
  }

  const label = document.querySelector('.pplr-colletto .pplrlabel');

  // nodo testo che contiene "Colletto "
  const firstTextNode = label.childNodes[0];
  
  // aggiungi il tuo testo dopo "Colletto"
  firstTextNode.textContent = firstTextNode.textContent.trim() + ' /  Collar ';


  const label1 = document.querySelector('.pplr-sostegno-colletto .pplrlabel');

  // scorre i nodi figli del label per trovare il testo "Sostegno colletto"
  for (const node of label1.childNodes) {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.includes('Sostegno colletto')) {
          node.textContent = node.textContent.trim() + ' /  Collar stays ';
          break;
      }
  }

  const label2 = document.querySelector('.pplr-polsini .pplrlabel');
  const firstTextNode2 = label2.childNodes[0];
  firstTextNode2.textContent = firstTextNode2.textContent.trim() + ' /  Cuffs ';

  const label3 = document.querySelector('.pplr-davanti .pplrlabel');
  const firstTextNode3 = label3.childNodes[0];
  firstTextNode3.textContent = firstTextNode3.textContent.trim() + ' /  Front ';

  const label4 = document.querySelector('.pplr-dietro .pplrlabel');
  const firstTextNode4 = label4.childNodes[0];
  firstTextNode4.textContent = firstTextNode4.textContent.trim() + ' /  Back ';

  const label5 = document.querySelector('.pplr-cuciture .pplrlabel');
  // scorre i nodi figli del label per trovare il testo "Sostegno colletto"
  for (const node of label5.childNodes) {
    if (node.nodeType === Node.TEXT_NODE && node.textContent.includes('Cuciture')) {
        node.textContent = node.textContent.trim() + ' /  Stitching ';
        break;
    }
}


  const label6 = document.querySelector('.pplr-taschino .pplrlabel');
  const firstTextNode6 = label6.childNodes[0];
  firstTextNode6.textContent = firstTextNode6.textContent.trim() + ' /  Pocket ';

  const label7 = document.querySelector('.pplr-numero-di-taschini .pplrlabel');
  const firstTextNode7 = label7.childNodes[0];
  firstTextNode7.textContent = firstTextNode7.textContent.trim() + ' /  Number of pockets ';

  const label8 = document.querySelector('.pplr-bottoni .pplrlabel');
  const firstTextNode8 = label8.childNodes[0];
  firstTextNode8.textContent = firstTextNode8.textContent.trim() + ' /  Buttons ';

  const label9 = document.querySelector('.pplr-cucitura-bottoni .pplrlabel');
  const firstTextNode9 = label9.childNodes[0];
  firstTextNode9.textContent = firstTextNode9.textContent.trim() + ' /  Seam ';

  const label10 = document.querySelector('.pplr-iniziali.pplr-dropdown .pplrlabel');
  const firstTextNode10 = label10.childNodes[0];
  firstTextNode10.textContent = firstTextNode10.textContent.trim() + ' /  Initials ';

  const label11 = document.querySelector('.pplr-iniziali.pplr-text .pplrlabel');
  const firstTextNode11 = label11.childNodes[0];
  firstTextNode11.textContent = firstTextNode11.textContent.trim() + ' /  Initials ';  
  
  const label12 = document.querySelector('.pplr-iniziali.pplr-color-select .pplrlabel');
  const firstTextNode12 = label12.childNodes[0];
  firstTextNode12.textContent = firstTextNode12.textContent.trim() + ' /  Colors ';

  const label12_1 = document.querySelector('.pplr-tipo-lettere .pplrlabel');
  const firstTextNode12_1 = label12_1.childNodes[0];
  firstTextNode12_1.textContent = firstTextNode12_1.textContent.trim() + ' /  Letter type ';

  const label13 = document.querySelector('.pplr-posizione .pplrlabel');
  const firstTextNode13 = label13.childNodes[0];
  firstTextNode13.textContent = firstTextNode13.textContent.trim() + ' /  Position ';

  const label14 = document.querySelector('.pplr-tipo .pplrlabel');
// scorre i nodi figli del label per trovare il testo "Sostegno colletto"
for (const node of label14.childNodes) {
  if (node.nodeType === Node.TEXT_NODE && node.textContent.includes('Tipo')) {
      node.textContent = node.textContent.trim() + ' /  Type ';
      break;
  }
}

const label15 = document.querySelector('.pplr-misure.pplr-dropdown .pplrlabel');
const firstTextNode15 = label15.childNodes[0];
firstTextNode15.textContent = firstTextNode15.textContent.trim() + ' /  Measurements ';

const label16 = document.querySelector('.pplr-misure-standard .pplrlabel');
  const firstTextNode16 = label16.childNodes[0];
  firstTextNode16.textContent = firstTextNode16.textContent.trim() + ' / Standard measurements ';


const label17 = document.querySelector('.pplr-text.pplr-collo .pplrlabel');
  const firstTextNode17 = label17.childNodes[0];
  firstTextNode17.textContent = firstTextNode17.textContent.trim() + ' / Collar ';

  const label18 = document.querySelector('.pplr-spalle .pplrlabel');
  const firstTextNode18 = label18.childNodes[0];
  firstTextNode18.textContent = firstTextNode18.textContent.trim() + ' / Shoulders ';

  const label19 = document.querySelector('.pplr-petto .pplrlabel');
  const firstTextNode19 = label19.childNodes[0];
  firstTextNode19.textContent = firstTextNode19.textContent.trim() + ' / Chest ';

  const label20 = document.querySelector('.pplr-vita .pplrlabel');
  const firstTextNode20 = label20.childNodes[0];
  firstTextNode20.textContent = firstTextNode20.textContent.trim() + ' / Waist ';
  
  const label21 = document.querySelector('.pplr-fianchi .pplrlabel');
  const firstTextNode21 = label21.childNodes[0];
  firstTextNode21.textContent = firstTextNode21.textContent.trim() + ' / Hips ';

  const label22 = document.querySelector('.pplr-lunghezza-manica .pplrlabel');
  const firstTextNode22 = label22.childNodes[0];
  firstTextNode22.textContent = firstTextNode22.textContent.trim() + ' / Sleeve lenght ';

  const label23 = document.querySelector('.pplr-bicipiti .pplrlabel');
  const firstTextNode23 = label23.childNodes[0];
  firstTextNode23.textContent = firstTextNode23.textContent.trim() + ' / Biceps ';

  const label24 = document.querySelector('.pplr-polso .pplrlabel');
  const firstTextNode24 = label24.childNodes[0];
  firstTextNode24.textContent = firstTextNode24.textContent.trim() + ' / Cuff ';

  const label25 = document.querySelector('.pplr-lunghezza-della-camicia .pplrlabel');
  const firstTextNode25 = label25.childNodes[0];
  firstTextNode25.textContent = firstTextNode25.textContent.trim() + ' / Shirt lenght ';

  const label26 = document.querySelector('.pplr-checkbox.pplr-vestibilit .pplrlabel');
  // scorre i nodi figli del label per trovare il testo "Sostegno colletto"
for (const node of label26.childNodes) {
  if (node.nodeType === Node.TEXT_NODE && node.textContent.includes('Vestibilità')) {
      node.textContent = node.textContent.trim() + ' /  Fitting ';
      break;
  }
}


}, 2000);
